import * as React from "react";
import {Button, Image} from "react-bootstrap";
import {CrossSellModel} from "../models/domain/crossSellModel";
import {StarRating} from "./starRating";
import {useAppContext} from "../hooks/useAppContext";
import {useCartService} from "../hooks/addToCart/useCartService";
import {truncateString} from "../utils/helpers";
import {CrossSellListType} from "../definitions/enums";

// Define a maximum title length
const MAX_TITLE_LENGTH = 65;

export const CrossSell = ({
                              listType,
                              model: {
                                  product: {
                                      productId,
                                      primaryId,
                                      customizeIt,
                                      dynamicDimensions,
                                      title,
                                      collectionName,
                                      path,
                                      href,
                                      minQuantity,
                                      sku
                                  },
                                  image: {
                                      src,
                                      alt,
                                      title: imageTitle
                                  },
                                  price: {
                                      onSale,
                                      salePercentage,
                                      formatted: {
                                          unitPrice,
                                          price
                                      }
                                  },
                                  ratingStatistics: {
                                      mean,
                                      count
                                  }
                              },
                              index
                          }:
                              {
                                  listType?: CrossSellListType,
                                  model: CrossSellModel,
                                  index: number
                              }) => {
    const {changeProduct} = useAppContext();
    const {createItem, setShow} = useCartService();

    return (
        <div className="carousel-item-wrapper d-flex align-items-center flex-column mx-1 px-1">
            <a href={path}
               tabIndex={0}
               role="link"
               className="d-block text-center product-link"
               data-ee-list={listType && listType}
               data-react="true"
               data-item-id={productId}
               data-position={index}
               data-sku={sku}
               onClick={(e) => {
                   e.preventDefault();
                   return changeProduct(productId, primaryId, path);
               }}>
                <Image src={src}
                       alt=""
                       width="155"
                       height="200"
                       className="img-fluid"
                       aria-hidden/>
                <div className="d-flex flex-wrap align-items-center flex-column">
                    <span className={`fs-5 fw-bold d-flex align-items-center m-auto text-dark`}>
                        {onSale && (
                            <del className="ms-1 fw-normal text-muted fw-normal fs-6 me-1">
                                {unitPrice}{" "}
                            </del>
                        )}
                        {dynamicDimensions && <span className="fs-6 fw-normal me-1">Starting at</span>}{price}
                    </span>
                    {onSale && (
                        <span className="text-danger fw-normal px-1 d-block m-auto">
                            Save {salePercentage && Math.round(salePercentage)}%
                        </span>
                    )}
                </div>
                {collectionName && (
                    <small className="d-block text-muted">
                        {collectionName}
                    </small>
                )}
                <div className="d-flex flex-wrap text-center cross-sell-title"
                     style={{fontSize: '.9em', lineHeight: '1.3em'}}>
                    {truncateString(title, MAX_TITLE_LENGTH)}
                </div>
                {count > 0 && (
                    <span className="review-stars d-block">
                        <StarRating grade={mean}/>
                        <small className="text-muted">
                            ({count})
                        </small>
                    </span>
                )}
            </a>
            <Button variant="warning"
                    className="add-to-cart-btn mt-2 text-center"
                    size="sm"
                    href={href}
                    data-ee-list={listType && listType}
                    data-item-id={productId}
                    data-quantity={minQuantity}
                    data-sku={sku}
                    onClick={async (e) => {
                        // Prevents the link
                        // from being followed
                        // to allow the request
                        // to be made locally without a page refresh
                        e.preventDefault();

                        if (customizeIt) {
                            setShow(false);
                            return changeProduct(productId, primaryId, path);
                        }
                        await createItem({
                            productId: productId,
                            quantity: null,
                            artworkId: null,
                            artworkName: null,
                            artworkNotes: null,
                            width: null,
                            height: null
                        });
                    }}>
                {customizeIt ? 'Customize It' : 'Add to Cart'}
            </Button>
        </div>
    );
};